export type ModalInstanceEntry = { props: unknown; onCloseCallback?: () => void };

export interface ModalInstanceRegistry {
  createId: () => string;
  set: (id: string, entry: ModalInstanceEntry) => void;
  getProps: (id: string) => unknown;
  getCloseCallback: (id: string) => (() => void) | undefined;
  getIds: () => string[];
  delete: (id: string) => void;
  clear: () => void;
}

let idCounter = 0;

export const createModalInstanceRegistry = (): ModalInstanceRegistry => {
  const instances = new Map<string, ModalInstanceEntry>();

  return {
    createId: () => {
      idCounter += 1;

      return `modal-${idCounter}`;
    },
    set: (id, entry) => {
      instances.set(id, entry);
    },
    getProps: (id) => instances.get(id)?.props,
    getCloseCallback: (id) => instances.get(id)?.onCloseCallback,
    getIds: () => Array.from(instances.keys()),
    delete: (id) => {
      instances.delete(id);
    },
    clear: () => {
      instances.clear();
    },
  };
};
